/**
 * @desc 地区层级_V2
 */

import { RequestConfig, request } from 'umi';

function req(useless?: any, config: Parameters<typeof request>[1] = {}) {
  return request<
    defs.store.GeneralHttpResponse<Array<defs.store.SubAreaRpcDTO>>
  >(`/storeapi/inner/address/store/areas`, {
    method: 'get',
    ...(config || {}),
  });
}
req.req = {} as Parameters<typeof req>[0];
req.res = {} as defs.store.GeneralHttpResponse<Array<defs.store.SubAreaRpcDTO>>;
export default req;
